import axios from "axios"
import { API_BASE_URL } from "../config"

export type SensitivitySettingSource = "medical_record" | "catv" | "system" | null
export type PeriodValue = string[] | null

export type SensitivitySettingListItem = {
  medical_record_id: string
  medical_record_uuid?: string
  catv_id?: string | null
  estate_id?: string | null
  estate_name?: string | null
  facility_id?: string | null
  facility_name?: string | null
  room_no?: string | null
  name?: string | null
  initial?: string | null
  sensitivity_enabled?: number | null
  sensitivity?: number | null
  detection_enabled?: number | null
  detection_period?: PeriodValue
  option_enabled?: number | null
  option_period?: PeriodValue
  effective_sensitivity_enabled?: number | null
  effective_sensitivity?: number | null
  effective_sensitivity_source?: SensitivitySettingSource
  effective_detection_enabled?: number | null
  effective_detection_period?: PeriodValue
  effective_detection_period_source?: SensitivitySettingSource
  effective_option_enabled?: number | null
  effective_option_period?: PeriodValue
  effective_option_period_source?: SensitivitySettingSource
}

export type SensitivitySettingUpdateItem = {
  medical_record_id: string
  sensitivity_enabled?: number | null
  sensitivity?: number | null
  detection_enabled?: number | null
  detection_period_start?: string | null
  detection_period_end?: string | null
  option_enabled?: number | null
  option_period_start?: string | null
  option_period_end?: string | null
}

export const getSensitivitySettingList = async (facilityId?: string | null) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/sensitivity_setting/list`, {
        session_code: localStorage.getItem("session_code"),
        facility_id: facilityId || null
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }

      return response.data
    } catch (error: any) {
      if (error.code && error.code === "ERR_NETWORK" && i !== 2) {
        continue
      }
      throw error
    }
  }
}

export const updateSensitivitySetting = async (items: SensitivitySettingUpdateItem[]) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/sensitivity_setting/update`, {
        session_code: localStorage.getItem("session_code"),
        items
      })

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }

      return response.data
    } catch (error: any) {
      if (error.code && error.code === "ERR_NETWORK" && i !== 2) {
        continue
      }
      throw error
    }
  }
}
